// Mirrors crm-backend/src/utils/passwordPolicy.js for instant feedback only;
// the backend re-validates everything and is the source of truth.
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 15;

export const PASSWORD_RULES = [
  {
    key: 'length',
    label: `${PASSWORD_MIN_LENGTH}–${PASSWORD_MAX_LENGTH} characters`,
    message: `Password must be between ${PASSWORD_MIN_LENGTH} and ${PASSWORD_MAX_LENGTH} characters.`,
    test: (p) => p.length >= PASSWORD_MIN_LENGTH && p.length <= PASSWORD_MAX_LENGTH
  },
  { key: 'uppercase', label: 'At least 1 uppercase letter', message: 'Password must contain at least one uppercase letter.', test: (p) => /[A-Z]/.test(p) },
  { key: 'lowercase', label: 'At least 1 lowercase letter', message: 'Password must contain at least one lowercase letter.', test: (p) => /[a-z]/.test(p) },
  { key: 'number', label: 'At least 1 number', message: 'Password must contain at least one number.', test: (p) => /\d/.test(p) },
  { key: 'special', label: 'At least 1 special character', message: 'Password must contain at least one special character.', test: (p) => /[^A-Za-z0-9]/.test(p) }
];

export const isPasswordValid = (password) => PASSWORD_RULES.every((rule) => rule.test(password || ''));

// First failing rule's message, or '' when valid.
export const passwordError = (password) => {
  if (!password) return 'Password is required.';
  const failed = PASSWORD_RULES.find((rule) => !rule.test(password));
  return failed ? failed.message : '';
};

export const PASSWORDS_DO_NOT_MATCH = 'Passwords do not match.';
